<div class="d-flex flex-row justify-content-between">
  <div
    [tabIndex]="0"
    class="d-flex flex-grow-1 flex-column align-items-center">
    <h2
      mat-dialog-title
      class="fs-1 mb-0 ps-5">
      {{ drugs.title }}
    </h2>
    <h3 class="fw-bold fs-5 mt-0 ps-5">{{ drugs.subtitle }}</h3>
  </div>
  <wfs-form-button
    (buttonClicked)="close()"
    [buttonStyle]="'close'"
    [overrideButtonMinWidth]="true"
    class="d-print-none pt-4 fs-2" />
</div>
<mat-dialog-content>
  <div class="body m-3">
    <!-- Drugs Table -->
    <div class="table-responsive">
      <table
        class="w-100 border tableLayout"
        [tabIndex]="0">
        <thead class="table-bordered mx-3 fs-5">
          <tr>
            <th class="px-2">{{ drugs.cannabis.title }}</th>
            <th class="px-2">{{ drugs.centralstimulants.title }}</th>
            <th class="px-2">{{ drugs.cocaine.title }}</th>
            <th class="px-2">{{ drugs.opiates.title }}</th>
            <th class="px-2">{{ drugs.hallucinogens.title }}</th>
            <th class="px-2">{{ drugs.solvent.title }}</th>
            <th class="px-2">{{ drugs.ghb.title }}</th>
          </tr>
        </thead>
        <tbody class="mx-3">
          @for (rowIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8]; track rowIndex) {
            <tr>
              <td class="px-2">{{ drugs.cannabis.subs[rowIndex] || '' }}</td>
              <td class="px-2">{{ drugs.centralstimulants.subs[rowIndex] || '' }}</td>
              <td class="px-2">{{ drugs.cocaine.subs[rowIndex] || '' }}</td>
              <td class="px-2">{{ drugs.opiates.subs[rowIndex] || '' }}</td>
              <td class="px-2">{{ drugs.hallucinogens.subs[rowIndex] || '' }}</td>
              <td class="px-2">{{ drugs.solvent.subs[rowIndex] || '' }}</td>
              <td class="px-2">{{ drugs.ghb.subs[rowIndex] || '' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Tablets Section -->
    <div class="text-center mt-3 lh-sm">
      <h3
        class="fs-2"
        [tabIndex]="0">
        {{ tablets.title }}
      </h3>
    </div>
    <div
      class="border lh-sm"
      [tabIndex]="0">
      <p class="ms-3 mt-3 fs-4 fw-bold">{{ tablets.tableheader }}</p>
      <ul class="ms-3 mt-1 fs-5">
        @for (sub of tablets.subs; track sub) {
          <li class="py-1">{{ sub }}</li>
        }
      </ul>
    </div>

    <!-- Tablets table -->
    <div class="table-responsive">
      <table
        class="w-100 border mt-3 tableLayout"
        [tabIndex]="0">
        <thead class="fs-4">
          <tr>
            <th
              colspan="2"
              class="text-center border px-2">
              {{ painkillers.title }}
            </th>
            <th
              colspan="2"
              class="text-center border px-2">
              {{ sedatives.title }}
            </th>
            <th class="text-center border px-2">{{ adhd.title }}</th>
          </tr>
        </thead>
        <tbody>
          @for (rowIndex of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track rowIndex) {
            <tr>
              <!-- Painkillers columns -->
              <td class="border-start px-2">{{ painkillers.subs[rowIndex] || '' }}</td>
              <td class="border-end px-2">
                {{ painkillers.subs[rowIndex + getSplitIndex(painkillers.subs.length)] || '' }}
              </td>
              <!-- Sedatives columns -->
              @if (rowIndex < 8) {
                <td class="border-start ps-3 px-2">{{ sedatives.subs[rowIndex] || '' }}</td>
              }
              @if (rowIndex >= 8) {
                <td class="border-start ps-3 px-2"></td>
              }
              <!-- Empty rows -->
              <td class="border-end px-2">
                {{ sedatives.subs[rowIndex + 8] || '' }}
              </td>
              <!-- ADHD column -->
              <td class="border-start border-end ps-3 px-2">{{ adhd.subs[rowIndex] || '' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Bottom Text Section -->
    <div class="d-flex justify-content-center align-items-center mt-5 mb-3">
      <div class="col-12 col-md-6 text-center">
        <p
          class="fs-4 fw-bold lh-sm"
          [tabIndex]="0">
          {{ drugs.bottomText }}
        </p>
      </div>
    </div>
  </div>
</mat-dialog-content>
<!-- Footer Section -->
<mat-dialog-actions class="flex-row justify-content-end">
  <wfs-form-button
    (buttonClicked)="close()"
    [label]="'Stäng'"
    [buttonStyle]="'warning'" />
</mat-dialog-actions>
